
import React from 'react';
import { useQuery, gql } from '@apollo/client';

import { Post } from './Post';

const GET_POSTS = gql`
    query Posts {
        posts {
            id
            title
            description
            engagements {
                id,
                engagementType
            }
            images {
                id
                url
            }
            poster {
                id
                name
            }
        }
    }
`;

const Posts: React.FC = () => {
    const { /* loading, error, */ data } = useQuery(GET_POSTS);

    return (
        <div>
            <h2>Posts</h2>
            {data && data.posts.map((post: any) => (
                <Post {...post} />
            ))}
        </div>
    );
};

export { Posts };
